/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-indent */
import React, {useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import * as Actions from '../../store/actions';
import {
  DashboardLayout,
  PageLimit,
  Pagination,
  PrimaryButton,
  TableLayout,
  EmptyState,
  Loader,
  SecondaryButton,
} from '../../components';
import {corruptedFile, eye, lookupEmpty} from '../../assets/images/images';
// import {Constants} from '../../helpers';
import {getCookieValue} from '../../helpers/getCookie';
import {PAGES_URL} from '../../helpers/constants';
import {COUNTRIES, tableHeader} from '../EasyLookup/LookupUtils';
import ResultsModal from './ResultsModal';
import SingleAnalysisModal from './SingleAnalysisModal';
import {useAllApps} from '../../hooks/useApps';
import {getStatusCodeDescription} from '../../helpers/getStatusCodeDescription';
// import {shortenLargeNumbers} from '../../helpers/shortenLargeNumbers';
import {OverviewCards} from '../../components/OverviewCards';
import {buildTableCardData} from '../../helpers/buildTableCardData';
import FilterV2 from '../../components/FilterV2';
import PageNumber from 'components/PageNumber';
import Breadcrumbs from 'components/BreadCrumbs';
import {dateRanges} from 'helpers/getDateRange';

const DOCUMENT_ANALYSIS_MODEL_TYPES = ['document_process'];

function SingleAnalysis({
  children,
  getLookupHistory,
  fetchLookup,
  changeLookupPage,
  getApiLogs,
  lookup: {history, h_loading, loading},
  auth: {userDetails},
  apiLogs: {logs, loading: apiLoading},
}) {
  const {userApps: allAppsData} = useAllApps();

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [openSingleAnalysis, setOpenSA] = useState(false);
  const [openPerformAnalysis, setOpenPA] = useState(false);
  const [results, setResults] = useState(null);
  const [filterValues, setFilterValues] = useState({
    date: 'seven_days',
    dateRange: dateRanges.seven_days(),
  });
  const [showFilter, setShowFilter] = useState(true);

  const env = getCookieValue('env');

  const appOptions =
    allAppsData?.map(app => ({
      value: app.value,
      label: app.label,
    })) || [];

  const statusOptions = [
    {value: 'complete', label: 'Successful'},
    {value: 'failed', label: 'Failed'},
    {value: 'pending', label: 'Pending'},
  ];

  const countryOptions = COUNTRIES.map(country => ({
    value: country.value,
    label: country.label,
  }));

  const allFilters = [
    ...(appOptions.length > 0
      ? [
          {
            key: 'app_id',
            label: 'Apps',
            type: 'select',
            options: appOptions,
          },
        ]
      : []),
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: statusOptions,
    },
    {
      key: 'country',
      label: 'Country',
      type: 'select',
      options: countryOptions,
    },
  ];

  const pageClick = selected => {
    setCurrentPage(selected);
  };

  const handleFilterChange = newFilters => {
    setFilterValues(newFilters);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (env === 'Sandbox') {
      Object.values(userDetails?.permissions?.logPermissions || {}).some(
        value => value,
      ) && getApiLogs({page: currentPage, limit});
    } else if (!children) {
      const apiParams = {
        company_id: userDetails?.company?.id,
        page: currentPage,
        limit,
        model_types: DOCUMENT_ANALYSIS_MODEL_TYPES,
        ...filterValues,
      };

      if (filterValues.dateRange) {
        apiParams.start = filterValues.dateRange.start;
        apiParams.end = filterValues.dateRange.end;
      } else if (filterValues.start_date && filterValues.end_date) {
        apiParams.start = filterValues.start_date;
        apiParams.end = filterValues.end_date;
      }

      if (filterValues.status) {
        apiParams.status = filterValues.status;
      }

      if (filterValues.country) {
        apiParams.country = Array.isArray(filterValues.country)
          ? filterValues.country.join(',')
          : filterValues.country;
      }

      if (filterValues.app_id) {
        apiParams.apps = Array.isArray(filterValues.app_id)
          ? filterValues.app_id
          : [filterValues.app_id];
      }

      localStorage.setItem('company_id', userDetails?.company?.id);

      allAppsData?.length > 0 &&
        currentPage &&
        getLookupHistory({...apiParams, documentUrl: 'document_analysis'});
    }
  }, [
    allAppsData?.length,
    currentPage,
    env,
    filterValues,
    getApiLogs,
    getLookupHistory,
    limit,
    userDetails?.company?.id,
  ]);

  const handleExport = () => {
    const apiParams = {
      company_id: userDetails?.company?.id,
      page: currentPage,
      limit: limit,
      model_types: DOCUMENT_ANALYSIS_MODEL_TYPES,
      download: true,
    };

    if (filterValues.dateRange) {
      apiParams.start = filterValues.dateRange.start;
      apiParams.end = filterValues.dateRange.end;
    } else if (filterValues.start_date && filterValues.end_date) {
      apiParams.start = filterValues.start_date;
      apiParams.end = filterValues.end_date;
    }

    if (filterValues.status) {
      apiParams.status = filterValues.status;
    }

    if (filterValues.country) {
      apiParams.country = Array.isArray(filterValues.country)
        ? filterValues.country.join(',')
        : filterValues.country;
    }

    if (filterValues.app_id) {
      apiParams.apps = Array.isArray(filterValues.app_id)
        ? filterValues.app_id
        : [filterValues.app_id];
    } else if (allAppsData?.length > 0) {
      apiParams.apps = allAppsData.map(app => app.value);
    }

    getLookupHistory(apiParams);
  };

  const toggleFilterVisibility = () => {
    setShowFilter(prevShowFilter => !prevShowFilter);
  };

  const SANDBOX_DATA = useMemo(
    () =>
      !apiLoading &&
      logs &&
      logs.api_logs?.map((log, index) => ({
        first_name: 'John',
        last_name: 'Doe',
        model_type: 'phone_number',
        model_type_id: index,
        status: 'complete',
        date_created: log?.createdAt,
      })),
    [logs && logs.api_logs.length],
  ) || [logs];

  useEffect(() => {
    if (env === 'Sandbox' && !apiLoading && logs) {
      setData(SANDBOX_DATA || []);
    } else if (!h_loading && history) {
      setData([...(history?.records || [])]);
    } else {
      setData([]);
    }
  }, [env, history, apiLoading, SANDBOX_DATA?.length, h_loading]);

  const isSearchOrFilter = !h_loading && history === undefined;

  const handleRefetch = () => {
    const apiParams = {
      company_id: userDetails?.company?.id,
      page: 1,
      model_type: DOCUMENT_ANALYSIS_MODEL_TYPES.join('&'),
      ...filterValues,
    };

    const app_ids = allAppsData?.map(app => app?.value);
    if (app_ids) {
      apiParams.apps = app_ids;
    }

    getLookupHistory(apiParams);
  };

  const {
    performSingleIndividualLookup: canPerformAndViewLookup,
    downloadIndividualLookup: canDownloadIndividualLookup,
  } =
    useMemo(() => userDetails?.permissions?.lookupPermissions, [userDetails]) ||
    {};

  const performRight =
    userDetails?.permissions?.role === 'Owner'
      ? false
      : !canPerformAndViewLookup;

  const tableCardData = buildTableCardData({
    count: history?.totalRecords,
  });

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Document Analysis</p>
      }
    >
      <SingleAnalysisModal
        open={openPerformAnalysis}
        setOpen={setOpenPA}
        refetch={handleRefetch}
      />
      <ResultsModal
        open={openSingleAnalysis}
        setOpen={setOpenSA}
        results={results}
      />

      {children ?? (
        <>
          <div className="flex items-center min-h-[52px] py-2 flex-wrap gap-3 justify-between mr-[-24px] ml-[-32px] px-8 border border-transparent border-b-[#E4E4E6]">
            <div className="flex items-center gap-2">
              <Breadcrumbs
                items={[
                  {
                    label: 'Document Analysis',
                    path: PAGES_URL.DOCUMENT_ANALYSIS,
                  },
                  {label: 'History'},
                ]}
              />
              {env !== 'Sandbox' && (
                <SecondaryButton
                  buttonText="Filter"
                  onClick={toggleFilterVisibility}
                />
              )}
            </div>
            <div className="flex items-center gap-2">
              <SecondaryButton
                buttonText="Export"
                className="w-[100px]"
                onClick={handleExport}
                disabled={!canDownloadIndividualLookup || loading}
                title={
                  !canDownloadIndividualLookup
                    ? 'You do not have permission to perform this action'
                    : ''
                }
                loading={loading}
              />
              <PrimaryButton
                buttonText="Perform Single Analysis"
                onClick={() => {
                  setOpenPA(!openPerformAnalysis);
                }}
              />
            </div>
          </div>

          <div className={`filter-slide-container ${showFilter ? 'open' : ''}`}>
            <FilterV2
              filters={allFilters}
              onFilterChange={handleFilterChange}
              initialValues={filterValues}
            />
          </div>

          <OverviewCards
            cardData={tableCardData}
            overviewLoading={h_loading}
            className={`grid grid-cols-2 md:grid-cols-3 xl:grid-cols-1 gap-2 lg:gap-4 flex-wrap my-5`}
          />

          <TableLayout negativeMargins>
            <thead className="font-semibold uppercase">
              <tr className="bg-white80">
                {tableHeader.map(({label, key}) => (
                  <th
                    key={key}
                    className={`${
                      label === 'Name'
                        ? 'pl-4 sm:pl-6 xl:pl-8 h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap'
                        : 'pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap'
                    }`}
                  >
                    <div className="flex items-end gap-1 cursor-pointer">
                      <span>{label}</span>
                    </div>
                  </th>
                ))}

                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td colSpan={8}>
                  {h_loading || (env === 'Sandbox' && apiLoading) ? (
                    <Loader height={50} />
                  ) : isSearchOrFilter ? (
                    <EmptyState
                      body="This filter did not return any data, try using different values."
                      src={corruptedFile}
                      noBtn
                      height={45}
                    />
                  ) : !apiLoading && data.length === 0 ? (
                    <EmptyState
                      height={45}
                      body="No historical record available"
                      onClick={() => setOpenPA(!openPerformAnalysis)}
                      src={lookupEmpty}
                      disabled={!userDetails?.company?.verified || performRight}
                      style={{
                        cursor:
                          (!userDetails?.company?.verified || performRight) &&
                          'not-allowed',
                      }}
                      imageHeight={48}
                      imageWidth={48}
                    />
                  ) : null}
                </td>
              </tr>
            </tbody>

            <tbody className="text-sm bg-white">
              {!(h_loading || (env === 'Sandbox' && apiLoading)) &&
                data &&
                data.map((record, i) => (
                  <tr
                    onClick={() => {
                      if (record.status_code !== '200') return;
                      setOpenSA(!openSingleAnalysis);
                      changeLookupPage(2);
                      fetchLookup({
                        id: record?.model_type_id,
                        type: record?.model_type,
                        history_id: record?.history_id,
                        documentUrl: `document-analysis`,
                        setResults,
                      });
                    }}
                    className="border-b cursor-pointer border-grey60 hover:bg-gray-50"
                    key={i}
                  >
                    <td className="p-4 pl-8 text-sm text-body whitespace-nowrap">
                      {`${record?.first_name?.toUpperCase() || '-'}  ${
                        record?.last_name?.toUpperCase() || '-'
                      }`}
                    </td>
                    <td className="p-4 pl-0 text-sm text-body whitespace-nowrap">
                      {record?.document_id_type?.replaceAll('_', ' ') || '-'}
                    </td>
                    <td className="p-4 pl-0 whitespace-nowrap">
                      <div
                        className={`px-2 pt-[5px] pb-[3px] text-xs font-medium uppercase rounded-full w-fit ${
                          record?.status_code === '200'
                            ? 'text-success20 bg-success'
                            : record?.status_code === '404'
                            ? 'text-white bg-status-404'
                            : 'bg-grey5'
                        }`}
                      >
                        {getStatusCodeDescription(record?.status_code)
                          ?.statusLabel || '-'}
                      </div>
                    </td>
                    <td className="p-4 pl-0 text-sm text-body whitespace-nowrap">
                      {moment(record?.date_created).format(
                        'MMM DD, YYYY hh:mmA',
                      ) || '-'}
                    </td>
                    {record.status === 'complete' && (
                      <td className="p-4 pl-0 whitespace-nowrap">
                        <div className="flex items-center gap-4">
                          <button
                            title="View"
                            onClick={e => {
                              e.stopPropagation();
                              setOpenSA(!openSingleAnalysis);
                              changeLookupPage(2);
                              env !== 'Sandbox' &&
                                fetchLookup({
                                  id:
                                    record?.entity_id || record?.model_type_id,
                                  type:
                                    record?.entity_type || record?.model_type,
                                  history_id:
                                    record?.entity_id || record?.history_id,
                                  documentUrl: 'document-analysis',
                                  setResults,
                                });
                            }}
                            className="h-4 aspect-square"
                          >
                            <img src={eye} alt="" />
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
            </tbody>
          </TableLayout>
          {!(h_loading || (env === 'Sandbox' && apiLoading)) &&
            data.length > 0 && (
              <div className="flex flex-wrap items-center justify-between gap-4 sm:gap-0 bg-white80 mx-[-32px] px-8 py-[18px] border-[0.5px] border-y-[#E4E3EC] border-transparent">
                <PageNumber
                  currentPage={+currentPage}
                  limit={limit}
                  totalCount={history?.totalRecords || 0}
                />
                <div className="flex items-center gap-5">
                  <PageLimit
                    onLimitChange={newLimit => {
                      setLimit(newLimit);
                      setCurrentPage(1);
                    }}
                    total={history?.totalRecords || 0}
                    length={data.length}
                    limit={limit}
                  />
                  <Pagination
                    total={Math.ceil((history?.totalRecords || 0) / limit)}
                    current={+currentPage}
                    onPageChange={activePage => pageClick(activePage)}
                  />
                </div>
              </div>
            )}
        </>
      )}
    </DashboardLayout>
  );
}

export default connect(state => state, Actions)(SingleAnalysis);
